var exports = {
  "q": "x8b4e8595--37ca21--visited-label",
};

module.exports = exports;
